const Routes = [];

/*** PUBLIC RULES */
Routes.push({
    path: "/m-cache",
    meta: {},
    name: "m-cache",
    component: () => import("@/modules/mcache/RootView")
});

export default Routes;